/**
 * Spanish (es) translations for TablixJS
 */
export const spanishTranslations = {
  // General
  'general.loading': 'Cargando...',
  'general.error': 'Error',
  'general.noData': 'No hay datos disponibles',
  'general.show': 'Mostrar',
  'general.entries': 'entradas',
  'general.of': 'de',
  'general.to': 'a',
  'general.records': 'registros',
  'general.perPage': 'por página',
  'general.showing': 'Mostrando',
  'general.total': 'Total',
  'general.rows': 'filas',

  // Search
  'search.placeholder': 'Buscar...',
  'search.clear': 'Limpiar búsqueda',
  'search.noResults': 'No se encontraron resultados',
  'search.resultsFound': 'resultados encontrados',

  // Pagination
  'pagination.first': 'Primero',
  'pagination.previous': 'Anterior',
  'pagination.next': 'Siguiente',
  'pagination.last': 'Último',
  'pagination.page': 'Página',
  'pagination.pageOf': 'Página {currentPage} de {totalPages}',
  'pagination.showingRecords': 'Mostrando {startRow} a {endRow} de {totalRows} registros',
  'pagination.noRecords': 'No se encontraron registros',
  'pagination.pageSize': 'Registros por página',

  // Sorting
  'sort.sortAscending': 'Ordenar ascendente',
  'sort.sortDescending': 'Ordenar descendente',
  'sort.sortedAscending': 'Ordenado ascendente',
  'sort.sortedDescending': 'Ordenado descendente',
  'sort.notSorted': 'Sin ordenar',
  'sort.clearSort': 'Limpiar ordenación',

  // Selection
  'selection.selectRow': 'Seleccionar fila',
  'selection.deselectRow': 'Deseleccionar fila',
  'selection.selectAll': 'Seleccionar todo',
  'selection.deselectAll': 'Deseleccionar todo',
  'selection.selectedCount': '{count} seleccionado(s)',
  'selection.selectAllVisible': 'Seleccionar todas las filas visibles',
  'selection.clearSelection': 'Limpiar selección',

  // Filtering
  'filter.filter': 'Filtrar',
  'filter.clearFilter': 'Limpiar filtro',
  'filter.clearAllFilters': 'Limpiar todos los filtros',
  'filter.applyFilter': 'Aplicar filtro',
  'filter.filterBy': 'Filtrar por',
  'filter.filterColumn': 'Filtrar columna',
  'filter.filterByValue': 'Filtrar por valor',
  'filter.filterByCondition': 'Filtrar por condición',
  'filter.searchValues': 'Buscar valores...',
  'filter.selectAll': 'Seleccionar todo',
  'filter.noValuesAvailable': 'No hay valores disponibles',
  'filter.addCondition': 'Agregar condición',
  'filter.removeCondition': 'Eliminar condición',
  'filter.value': 'Valor',
  'filter.apply': 'Aplicar',
  'filter.clear': 'Limpiar',
  'filter.cancel': 'Cancelar',
  'filter.contains': 'Contiene',
  'filter.startsWith': 'Comienza con',
  'filter.endsWith': 'Termina con',
  'filter.equals': 'Igual a',
  'filter.notEquals': 'No igual a',
  'filter.greaterThan': 'Mayor que',
  'filter.lessThan': 'Menor que',
  'filter.greaterThanOrEqual': 'Mayor o igual a',
  'filter.lessThanOrEqual': 'Menor o igual a',
  'filter.between': 'Entre',
  'filter.isEmpty': 'Está vacío',
  'filter.isNotEmpty': 'No está vacío',
  'filter.selectValues': 'Seleccionar valores',
  'filter.noOptionsAvailable': 'No hay opciones disponibles',
  'filter.complexDataNotSupported': 'El filtrado por valor no está disponible para columnas con datos complejos. Utilice el filtrado por condición en su lugar.',

  // Controls
  'controls.refresh': 'Actualizar datos',
  'controls.export': 'Exportar datos',
  'controls.settings': 'Configuración',
  'controls.columns': 'Columnas',
  'controls.showColumns': 'Mostrar/Ocultar columnas',

  // Virtual Scrolling
  'virtualScroll.loadingMoreRows': 'Cargando más filas...',
  'virtualScroll.scrollToTop': 'Desplazar hacia arriba',
  'virtualScroll.scrollToBottom': 'Desplazar hacia abajo',

  // Error Messages
  'error.loadingData': 'Error al cargar los datos',
  'error.networkError': 'Error de red',
  'error.invalidData': 'Formato de datos inválido',
  'error.serverError': 'Error del servidor',
  'error.timeout': 'Tiempo de espera agotado',
  'error.unknown': 'Ocurrió un error desconocido',
  'error.retry': 'Reintentar',

  // Data Types
  'dataType.string': 'Texto',
  'dataType.number': 'Número',
  'dataType.date': 'Fecha',
  'dataType.boolean': 'Booleano',
  'dataType.currency': 'Moneda',
  'dataType.percentage': 'Porcentaje',

  // Accessibility
  'accessibility.table': 'Tabla de datos',
  'accessibility.sortableColumn': 'Columna ordenable',
  'accessibility.selectableRow': 'Fila seleccionable',
  'accessibility.rowSelected': 'Fila seleccionada',
  'accessibility.rowNotSelected': 'Fila no seleccionada',
  'accessibility.pageNavigation': 'Navegación de páginas',
  'accessibility.searchInput': 'Buscar en los datos de la tabla',
  'accessibility.filterColumn': 'Filtrar columna',

  // Actions
  'action.apply': 'Aplicar',
  'action.cancel': 'Cancelar',
  'action.close': 'Cerrar',
  'action.save': 'Guardar',
  'action.reset': 'Restablecer',
  'action.ok': 'OK',
  'action.yes': 'Sí',
  'action.no': 'No',

  // Time and Date
  'date.today': 'Hoy',
  'date.yesterday': 'Ayer',
  'date.thisWeek': 'Esta semana',
  'date.lastWeek': 'La semana pasada',
  'date.thisMonth': 'Este mes',
  'date.lastMonth': 'El mes pasado',

  // Numbers and Formatting
  'format.currency.symbol': '€',
  'format.decimal.separator': ',',
  'format.thousand.separator': '.',
  'format.percentage.symbol': '%'
};

export default spanishTranslations;
